import React from "react";
import { ArrowLeftSLine1 } from "../../icons/ArrowLeftSLine1";
import "./style.css";

export const ArrowLeftSLine = () => {
  return <ArrowLeftSLine1 className="arrow-left-s-line-1" color="#14142B" />;
};
